import { Component, OnInit, Input } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap';
import { Subject, Observable } from 'rxjs';
import { HttpService } from '../../../shared/_services/http.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { HcaMemberService } from '../../../shared/_services/hca-member.service';
import { EmployeeService } from '../../../shared/_services/employee.service';

@Component({
  selector: 'app-add-comment',
  templateUrl: './add-comment.component.html',
  styleUrls: ['./add-comment.component.scss']
})
export class AddCommentComponent implements OnInit {
  errorMsg: string;
  successMsg: any;
  memberId: number | string = null;
  comments: FormGroup;
  tagInputText: string;
  items = [];
  srcObject: any = [];
  employeeId: number | string = null;
  searchTerm$ = new Subject<string>();
  hotelTags: (text: string) => Observable<Response>;
  errorDetails: string;
  errorUpload: boolean;

  constructor(
    private fb: FormBuilder,
    private http: HttpService,
    public bsModalRef: BsModalRef,
    private employeeService: EmployeeService,
    private hcaMemberService: HcaMemberService
  ) {
    this.hotelTags = (text: string): Observable<Response> => {
      const url = `/hotel/getHotelTags/hotel/${text}`;
      return this.http
        .get(url).debounceTime(300)
        .distinctUntilChanged()
        .map(data => {
          if (data.json().error == 0) {
            if (data.json().responseObj.length) {
              return data.json().responseObj
            } else {
              this.tagInputText = "";
            }
          }
        });
    }
  }

  save() {
    let serviceFunction = this.employeeId ? {service: 'employeeService', api: 'saveEmployeeComments'} : {service: 'hcaMemberService', api: 'saveAdminComments'};
    this[serviceFunction.service][serviceFunction.api](this.comments.value).subscribe(res => {
      this.successMsg = 'Comments saved successfully';
      setTimeout(() => {
        this.successMsg = '';
        this.srcObject.action = "action1";
        this.bsModalRef.hide();
      }, 1500);
    }, err => {
      console.error('Error while adding comments: ', err.message);
      this.errorMsg = err ? err.message : 'Error while saving comments';
      setTimeout(() => {
        this.errorMsg = '';
      }, 1500);
    })
  }

  initForm(type?, personId?) {
    this.comments = this.fb.group({
      memberId: [personId ? personId : ''],
      comments: ['', Validators.compose([Validators.required, Validators.maxLength(1000)])],
      tags: [null]
    });
  }

  ngOnInit() {
    this.initForm();
    setTimeout(() => {
      console.log('employee', this.employeeId);
      if (this.memberId) {
        this.initForm('member', this.memberId);
      }
      if(this.employeeId) {
        this.initForm('employee', this.employeeId);
      }
    }, 100);
  }

  closeModal() {
    this.bsModalRef.hide();
  }
}



// WEBPACK FOOTER //
// ./src/app/components/modals/add-comment/add-comment.component.ts